import React from 'react';
import { useLang } from '../../shared/i18n';
import { MARKETING_HOME } from './marketingHome';

const AuthLegalNotice: React.FC = () => {
    const { t } = useLang();

    return (
        <p className="auth-legal-notice">
            {t('legalNoticePrefix')}{' '}
            <a
                href={`${MARKETING_HOME}/legal/GTC/`}
                target="_blank"
                rel="noopener noreferrer"
            >
                {t('legalNoticeGtc')}
            </a>
            {' '}{t('legalNoticeAnd')}{' '}
            <a
                href={`${MARKETING_HOME}/legal/privacy/`}
                target="_blank"
                rel="noopener noreferrer"
            >
                {t('legalNoticePrivacy')}
            </a>
            {t('legalNoticeSuffix')}
        </p>
    );
};

export default AuthLegalNotice;
